import create from 'zustand';
import produce from 'immer';
import arrayMove from 'array-move';

const BLANK_CREATE_INITIAL = {
	blank: {
		title: '',
		gradeId: 0,
		courses: []
	}
};

export const useBlankCreateStore = create(set => ({
	...BLANK_CREATE_INITIAL,

	// Handle state change
	onChange: ({ name, value }) => set(produce(state => {
		state.blank[name] = value;
	})),

	// Handle course addition
	onAddCourse: (course) => set(produce(state => {
		state.blank.courses.push(course);
	})),

	// Handle course addition
	onRemoveCourse: (id) => set(produce(state => {
		state.blank.courses = state.blank.courses.filter(course => course.id !== id);
	})),

	// Handle course sort
	onSortCourse: ({ oldIndex, newIndex }) => set(produce(state => {
		// Sort courses by given indexes
		const sorted = arrayMove(state.blank.courses, oldIndex, newIndex);

		// Update course order
		state.blank.courses = sorted.map((course, idx) => ({
			...course,
			order: idx + 1
		}));
	})),

	// Reset store to initial state
	onReset: () => set({
		...BLANK_CREATE_INITIAL
	})
}));